import React from "react";

import { Slot } from "@radix-ui/react-slot";

import { cn } from "../index";

interface IconButtonProps extends React.ComponentPropsWithoutRef<"button"> {
  asChild?: boolean;
}

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ asChild, type, className, ...props }, forwardedRef) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        {...props}
        ref={forwardedRef}
        type={type ?? "button"}
        className={cn(
          `h-10 w-10 flex cursor-pointer items-center justify-center rounded-[10px] bg-primary-white text-primary-dark-blue select-none active:bg-primary-gray`,
          className,
        )}
      />
    );
  },
);

IconButton.displayName = "IconButton";

export { IconButton };
export type { IconButtonProps };
